<template>
  <div class="park-warp">
    <div class="map-data-setting-1">
      <area-division class="map-1" :title="areaInfo.title || ''" :ps-txt="areaInfo.ps_title" :list="areaList" />
      <div class="setting-warp setting-1">
        <el-form :inline="true" label-position="right" label-width="110px" class="form" :model="areaInfo">
          <el-form-item class="wh-form-item" required label="标题">
            <el-input v-model="areaInfo.title" />
          </el-form-item>
          <el-form-item class="wh-form-item" label="副标题">
            <el-input v-model="areaInfo.ps_title" placeholder="非必填项" />
          </el-form-item>
          <el-form-item class="wh-form-item" required label="辖区面积">
            <el-input v-model="areaInfo.data[0]" type="number" />
          </el-form-item>
          <el-form-item class="wh-form-item" required label="乡镇">
            <el-input v-model="areaInfo.data[1]" />
          </el-form-item>
          <el-form-item class="wh-form-item" required label="行政村(社区)">
            <el-input v-model="areaInfo.data[2]" />
          </el-form-item>
          <el-form-item class="wh-form-item" required label="人口">
            <el-input v-model="areaInfo.data[3]" />
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="map-data-setting-1 m-top">
      <industry-pillar
        class="map-1"
        :title="pillarInfo.title || ''"
        :ps-txt="pillarInfo.ps_title"
        :list="pillarInfo.data.list || []"
        :total="Number.parseFloat(pillarInfo.data.total || 0)"
      />
      <div class="setting-warp setting-2">
        <el-form :inline="true" label-position="right" label-width="110px" class="form" :model="pillarInfo">
          <el-form-item class="wh-form-item" required label="标题">
            <el-input v-model="pillarInfo.title" />
          </el-form-item>
          <el-form-item class="wh-form-item" label="副标题">
            <el-input v-model="pillarInfo.ps_title" placeholder="非必填项" />
          </el-form-item>
          <el-form-item
            v-for="(item, index) in pillarInfo.data.list"
            :key="index"
            class="wh-form-item"
            :label="item.name"
          >
            <template #label>
              <div class="pillar-info-label">{{item.name}}</div>
            </template>
            <el-input v-model="item.num" type="number" @input="pillarInputFn(item)" />
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="map-data-setting-1 m-top">
      <energy-ring
        class="map-1"
        :title="energyConsumptionInfo.title || ''"
        :ps-txt="energyConsumptionInfo.ps_title"
        :energy-consumption-data="energyConsumptionData"
      />
      <div class="setting-warp setting-2">
        <el-form :inline="true" label-position="right" label-width="110px" class="form" :model="energyConsumptionInfo">
          <el-form-item class="wh-form-item" required label="标题">
            <el-input v-model="energyConsumptionInfo.title" />
          </el-form-item>
          <el-form-item class="wh-form-item" label="副标题">
            <el-input v-model="energyConsumptionInfo.ps_title" placeholder="非必填项" />
          </el-form-item>
          <template
            v-for="(item, index) in energyConsumptionData"
          >
            <el-form-item
              :key="`${item.name}${index}`"
              class="wh-form-item"
              required
              :label="item.name"
            >
              <el-input v-model="item.num" type="number" />
            </el-form-item>
            <el-form-item
              :key="`${index}`"
              class="wh-form-item"
              required
              :label="`${item.name}转换值`"
            >
              <el-input v-model="item.transform_num" type="number" />
            </el-form-item>
          </template>
        </el-form>
      </div>
    </div>
    <div class="map-data-setting-1 m-top">
      <unit-energy class="map-1" :title="unitEnergyConsumption.title || ''" :ps-title="unitEnergyConsumption.ps_title || ''" :option="left4Option" />
      <div class="setting-warp unit-table setting-2">
        <el-form :inline="true" label-position="right" label-width="110px" class="form" :model="unitEnergyConsumption">
          <el-form-item class="wh-form-item" required label="标题">
            <el-input v-model="unitEnergyConsumption.title" />
          </el-form-item>
          <el-form-item class="wh-form-item" label="副标题">
            <el-input v-model="unitEnergyConsumption.ps_title" placeholder="非必填项" />
          </el-form-item>
        </el-form>
        <el-table
          :data="unitData"
          height="220"
          class="input-table"
        >
          <el-table-column
            label="年份"
            width="200"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div class="input-box">
                <el-input v-model="scope.row.date" size="small" />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="数值"
            min-width="100"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div class="input-box">
                <el-input v-model="scope.row.num" size="small" />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="120"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div class="txt-box">
                <el-button type="danger" size="mini" @click="deleteData(scope.$index)">
                  删除
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-button class="add-btn" size="mini" @click="addData">
          增加一列
        </el-button>
      </div>
    </div>
    <div class="map-data-setting-1 m-top">
      <date-energy class="map-3" :date-energy-consumption="dateEnergyConsumption" />
      <div class="setting-warp setting-2">
        <el-form :inline="true" label-position="right" label-width="110px" class="form" :model="pillarInfo">
          <el-form-item class="wh-form-item" required label="标题">
            <el-input v-model="dateEnergyConsumption.title" />
          </el-form-item>
          <el-form-item class="wh-form-item" label="副标题">
            <el-input v-model="dateEnergyConsumption.ps_title" placeholder="非必填项" />
          </el-form-item>
        </el-form>
        <el-table
          :data="tableData"
          class="input-table"
        >
          <el-table-column
            label="类别"
            width="100"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div class="txt-box">
                {{ scope.row.title }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="电力"
            min-width="100"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div class="input-box">
                <el-input v-model="scope.row.electric" size="small" @input="tableInputFn" />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="天然气"
            min-width="100"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div class="input-box">
                <el-input v-model="scope.row.gas" size="small" @input="tableInputFn" />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="煤炭"
            min-width="100"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div class="input-box">
                <el-input v-model="scope.row.coal" size="small" @input="tableInputFn" />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="其他"
            min-width="100"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div class="input-box">
                <el-input v-model="scope.row.other" size="small" @input="tableInputFn" />
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="save-btn wh-flex-center">
      <el-button class="next-btn" type="" icon="el-icon-right" circle title="前往企业数据管理" @click="$router.push('/agency')" />
      <el-button class="up-btn" plain icon="el-icon-download" @click="saveFn">
        保存并下载当前数据
      </el-button>
      <div class="up-warp">
        <wh-uploader
          ref="upFile"
          :not-pic="true"
          :is-private="true"
          :valid-ext="['json']"
          :preset-file-list="upFile || []"
          :limit="1"
          :before-upload-request-handle="beforeUploadFn"
          @listChanged="upFile=$event.fileListResult"
        >
          <div slot="trigger" class="upload-file">
            <el-button plain icon="el-icon-upload2">
              点击上传资料
            </el-button>
          </div>
        </wh-uploader>
        <span class="btn-tips">(上传文件名必须是park_data.json文件，否则无效)</span>
      </div>
    </div>
  </div>
</template>

<script>
import AreaDivision from '@/views/Home/components/MapItem/AreaDivision'
import { mapState, mapGetters } from 'vuex'
import IndustryPillar from '@/views/Home/components/MapItem/IndustryPillar'
import { deepCopy, mergeArrToObj, fileDownload } from '@/utils/tool'
import EnergyRing from '@/views/Home/components/MapItem/EnergyRing'
import DateEnergy from '@/views/Home/components/MapItem/DateEnergy'
import UnitEnergy from '@/views/Home/components/MapItem/UnitEnergy'
import echarts from 'echarts'
import WhUploader from '@/components/WhUploader/WhUploader'
export default {
  name: 'ParkData',
  components: { WhUploader, UnitEnergy, DateEnergy, EnergyRing, IndustryPillar, AreaDivision },
  data() {
    return {
      areaList: [
        {
          icon: 'jurisdiction-area.png',
          name: '辖区面积',
          remarks: '',
          num: 0,
          unit: '平方公里'
        },
        {
          icon: 'house-icon.png',
          name: '乡镇',
          remarks: '',
          num: 0,
          unit: '个'
        },
        {
          icon: 'village-icon.png',
          name: '行政村',
          remarks: '社区',
          num: 0,
          unit: '个'
        },
        {
          icon: 'men-icon.png',
          name: '人口',
          remarks: '',
          num: 0,
          unit: '万人'
        }
      ],
      areaInfo: {
        title: '行政区划',
        'ps_title': '',
        data: [0, 0, 0, 0]
      },
      pillarInfo: {
        'title': '产业支柱',
        'ps_title': '',
        'data': {
          'total': 599,
          'list': [
            {
              'name': '总入驻企业',
              'num': 599
            },
            {
              'name': '能源化工产业',
              'num': 1
            },
            {
              'name': '电子信息产业',
              'num': 10
            },
            {
              'name': '汽车机械产业',
              'num': 400
            },
            {
              'name': '新型材料产业',
              'num': 598
            },
            {
              'name': '轻纺产业',
              'num': 598
            },
            {
              'name': '生产性服务产业',
              'num': 598
            }
          ]
        }
      },
      energyConsumptionInfo: {},
      energyConsumptionData: [],
      unitEnergyConsumption: { data: [] },
      left4Option: {
        tooltip: {
          trigger: 'item',
          formatter: '{b}<br/>产值能耗：{c}tce/万元'
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          nameTextStyle: {
            fontSize: 40
          },
          axisLine: {
            lineStyle: {
              color: '#fff'
            }
          },
          axisTick: {
            show: false
          },
          data: []
        },
        yAxis: {
          show: false,
          type: 'value'
        },
        series: {
          data: [],
          type: 'line',
          label: {
            show: true,
            position: 'top',
            fontSize: 16,
            formatter: '{c}'
          },
          symbolSize: 14,
          smooth: false,
          color: '#2085E4',
          areaStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#2085E4' },
                { offset: 1, color: 'rgba(53,232,206,0)' }
              ])
            }
          }
        }
      },
      dateEnergyConsumption: { data: {}},
      unitData: [],
      tableData: [],
      upFile: []
    }
  },
  computed: {
    ...mapState([
      'upToken'
    ]),
    ...mapGetters({
      'initAreaInfo': 'areaInfo',
      'initPillarInfo': 'pillarInfo',
      'initEnergyConsumptionInfo': 'energyConsumptionInfo',
      'initEnergyConsumptionData': 'energyConsumptionData',
      'initUnitEnergyConsumption': 'unitEnergyConsumption',
      'initDateEnergyConsumption': 'dateEnergyConsumption'
    })
  },
  watch: {
    initAreaInfo: {
      handler(newV, oldV) {
        this.areaInfo = deepCopy(newV)
      },
      immediate: true,
      deep: true
    },
    initPillarInfo: {
      handler(newV, oldV) {
        this.pillarInfo = deepCopy(newV)
      },
      immediate: true,
      deep: true
    },
    initEnergyConsumptionInfo: {
      handler(newV, oldV) {
        this.energyConsumptionInfo = deepCopy(newV)
      },
      immediate: true,
      deep: true
    },
    initEnergyConsumptionData: {
      handler(newV, oldV) {
        this.energyConsumptionData = deepCopy(newV)
      },
      immediate: true,
      deep: true
    },
    initUnitEnergyConsumption: {
      handler(newV, oldV) {
        this.unitEnergyConsumption = deepCopy(newV)
      },
      immediate: true,
      deep: true
    },
    unitEnergyConsumption: {
      handler(newV, oldV) {
        this.left4Option.xAxis.data = newV.data.map(item => item.date)
        this.left4Option.series.data = newV.data.map(item => item.num)
        this.unitData = newV.data
      },
      immediate: true,
      deep: true
    },
    initDateEnergyConsumption: {
      handler(newV, oldV) {
        this.dateEnergyConsumption = deepCopy(newV)
      },
      immediate: true,
      deep: true
    },
    dateEnergyConsumption: {
      handler(newV, oldV) {
        const keyList = ['electric', 'gas', 'coal', 'other']
        this.tableData = ['月', '季度', '年'].map((item, index) => {
          let temp = {}
          if (index === 0) {
            temp = newV.data.m
          } else if (index === 1) {
            temp = newV.data.q
          } else if (index === 2) {
            temp = newV.data.y
          }
          return {
            title: item,
            ...mergeArrToObj(keyList, temp)
          }
        })
      },
      immediate: true,
      deep: true
    },
    areaInfo: {
      handler(newV, oldV) {
        this.areaList = this.areaList.map((item, index) => {
          return {
            ...item,
            num: newV.data[index] || 0
          }
        })
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    pillarInputFn(item) {
      if (item.name === '总入驻企业') {
        this.pillarInfo.data.total = item.num
      }
    },
    tableInputFn() {
      this.dateEnergyConsumption.data.m = [this.tableData[0].electric, this.tableData[0].gas, this.tableData[0].coal, this.tableData[0].other]
      this.dateEnergyConsumption.data.q = [this.tableData[1].electric, this.tableData[1].gas, this.tableData[1].coal, this.tableData[1].other]
      this.dateEnergyConsumption.data.y = [this.tableData[2].electric, this.tableData[2].gas, this.tableData[2].coal, this.tableData[2].other]
    },
    addData() {
      this.unitData.push({
        date: '',
        num: 0
      })
    },
    deleteData(index) {
      this.unitData.splice(index, 1)
    },
    saveFn() {
      this.$confirm('点击确定保存保存并下载后, 新数据将会被下载', '温馨提示', {
        confirmButtonText: '保存并下载',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const temp = {
          data: {
            areaInfo: this.areaInfo,
            pillarInfo: this.pillarInfo,
            energyConsumptionInfo: {
              ...this.energyConsumptionInfo,
              data: this.energyConsumptionData
            },
            unitEnergyConsumption: this.unitEnergyConsumption,
            dateEnergyConsumption: this.dateEnergyConsumption
          }
        }
        this.$message.success('开始下载数据到本地')
        fileDownload(JSON.stringify(temp), 'park_data.json')
      }).catch(() => {})
    },
    beforeUploadFn(file) {
      // localStorage.setItem('upFile', deepCopy(file))
      return new Promise((resolve, reject) => {
        const Bearer = `Bearer ` + `${this.upToken.access_token}`
        this.$Api.fileToken({
          file_name: file.file.name.replace('%', '').replace(',', ''),
          bucket_name: 'dazhou',
          ...{}
        }, false, {
          headers: {
            Authorization: Bearer
          }
        }).then(res => {
          const fd = new FormData()
          fd.append('file', file.file)
          fd.append('token', res.token)
          fd.append('key', res.key)
          resolve(fd)
        }).catch(err => {
          this.$message.warning('获取token失败:' + err)
          reject(err)
        })
      })
    },
    newFormData(file, token, key) {
      const fd = new FormData()
      fd.append('file', file)
      fd.append('token', token)
      fd.append('key', key)
      return fd
    }
  }
}
</script>

<style lang="less" scoped>
.form{
  display: grid;
  grid-template-columns: repeat(2,1fr);
}
.pillar-info-label{
  font-size: 12px;
  &:before{
    content: '*';
    color: #F56C6C;
    margin-right: 4px;
  }
}
  .park-warp{
    min-height: 600px;
    padding: 0 30px 40px;
    position: relative;
    .map-data-setting-1{
      display: flex;
      justify-content: center;
      align-items: flex-start;
    }
    .map-data-setting-2{
      /*display: flex;*/
      /*justify-content: flex-start;*/
      /*align-items: flex-start;*/
    }
    .setting-warp{
      width: 700px;
      padding: 20px;
      margin-left: 40px;
      background-color: rgba(231, 239, 249, 0.1);
      border-radius: 6px;
    }
    .setting-1{
      height: 240px;
    }
    .setting-2{
      height: 351px;
    }
  }
  .map-1{
    width: 455px;
  }
  .map-3{
    width: 928px;
  }
  /deep/ input::-webkit-outer-spin-button,
  /deep/ input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
  /deep/ input[type='number'] {
    -moz-appearance: textfield;
  }
  /deep/ .input-table{
    background-color: transparent!important;
    thead{
      tr{
        th{
          text-align: center;
          color: #fff;
        }
      }
    }
    tr{
      background-color: transparent!important;
      th{
        background-color: transparent!important;
      }
    }
    tr:hover>td{
      background-color: transparent!important;
    }
  }
  .txt-box{
    text-align: center;
    color: #fff;
  }
  .unit-table{
    text-align: right;
    .add-btn{
      margin-top: 10px;
    }
  }
  .save-btn{
    padding: 20px;
    text-align: center;
    .up-btn{
      margin-left: 20px;
      margin-right: 20px;
    }
    /deep/ .el-button{
      width: 200px;
    }
  }
  .up-warp{
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    .btn-tips{
      margin-left: 4px;
      color: #fff;
      font-size: 12px;
    }
  }
  .next-btn{
    width: 40px!important;
  }
</style>
<style lang="less">
  body{
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    &::-webkit-scrollbar {
      display: none;
    }
  }
</style>
